import React, { useMemo } from 'react';

import { groupBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import ListObjectFilter from 'common-ui/lists/listObjectFilter';
import { PortfolioListing } from 'core/lib';
import { OBJECT_TYPES } from 'core/lib/constants';

type PortfoliosByTaskOwnerProps = {
  data?: PortfolioListing[];
};

const PortfoliosByTaskOwner = ({ data }: PortfoliosByTaskOwnerProps) => {
  const { t } = useTranslation();

  const dataByTaskOwner = useMemo(
    () => groupBy(data, (d) => d.taskOwner?.name ?? t('global:results.notSpecified')),
    [data, t]
  );

  return (
    <ListObjectFilter<PortfolioListing>
      placeholder={t('portfolio:placeholders.searchTaskOwner')}
      data={dataByTaskOwner}
      title={t('portfolio:dashboards.titles.taskOwner')}
      objectType={OBJECT_TYPES.PORTFOLIO}
    />
  );
};

export default PortfoliosByTaskOwner;
